const FETCH_DPC_OVERVIEW = "v3/partner/:partnerId/getDpcOverview";

const FETCH_DPC_SERVICE_HISTORY = "v3/dpc/:dpcId/fetchServiceHistory";

const FETCH_SERVICE = "v3/service/partner/:serviceId/fetchService";

const UPDATE_SERVICE = "v3/service/partner/:serviceId/update";

const FETCH_DPC_DATA = "v3/dpc/:dpcId/fetchDpcData";

const FETCH_DPC_MESSAGES = "v3/partner/:partnerId/messages/:dpcId";
const UPDATE_MESSAGE_STATUS = "v3/partner/:partnerId/messages/:messageId/status";

export {
  FETCH_DPC_OVERVIEW,
  FETCH_DPC_SERVICE_HISTORY,
  FETCH_SERVICE,
  UPDATE_SERVICE,
  FETCH_DPC_DATA,
  FETCH_DPC_MESSAGES,
  UPDATE_MESSAGE_STATUS,
};
